let observer: ResizeObserver | null = null;

export const fitText = (snippet: HTMLElement) => {
  const child = snippet.firstElementChild as HTMLElement;
  if (!child) return;
  
  if (!observer) {
    observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target as HTMLElement;
        fitText(el);
      });
    });
  }

  observer.observe(snippet);

  child.style.fontSize = '';

  let fontSize = parseFloat(getComputedStyle(child).fontSize);

  const minFontSize = 10;
  const step = 1;

  const forceShrink = snippet.dataset.forceShrink === 'true';

  if (forceShrink) {
    child.style.flexWrap = 'nowrap';
  }

  const hasOverflow = () => {
    return child.scrollWidth > snippet.clientWidth;
  };

  while (hasOverflow() && fontSize > minFontSize) {
    fontSize -= step;
    child.style.fontSize = fontSize + 'px';
  }

  if (forceShrink) {
    child.style.flexWrap = '';
  }

  const values = snippet.querySelectorAll<HTMLElement>('.js-justify-text-value');
  values.forEach((el) => el.classList.remove('opacity-0'));
};